<section class="row mb-4 pl-2 border-left">
  <!-- <section class="row mb-4 pl-2 border-left"> -->
  <section class="col-12 mb-4 mt-4 border-bottom">
    <footer class="row">
      <h2 class="col-9 h5 font-weight-bold mb-2">Datos del prestador</h2>
      <p class="col-3 small">
        Última actualización:
        <strong>{{
          informacionEstablecimiento.fecha_ultima_actualizacion
            | date: "d/MMM/yyyy, h:mm a"
        }}</strong>
      </p>
      <ng-container
        *ngIf="
          informacionEstablecimiento.tipo_rnt !== tipo_rnt_guia;
          else es_guia
        "
      >
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Representante legal</label>
          <p>
            <strong>{{
              informacionEstablecimiento.nombre_representante_legal
            }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Número identificación</label>
          <p>
            <strong>{{
              informacionEstablecimiento.numero_identificacion_representante_legal
            }}</strong>
          </p>
        </div>
      </ng-container>
      <ng-template #es_guia>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Número identificación</label>
          <p>
            <strong>{{
              informacionEstablecimiento.numero_identificacion
            }}</strong>
          </p>
        </div>
      </ng-template>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Patrimonio neto</label>
        <p>
          <strong>{{
            informacionEstablecimiento.patrimonio_neto | currency: "COP"
          }}</strong>
        </p>
      </div>
      <div
        class="col-sm-12 col-md-3"
        *ngIf="informacionEstablecimiento.tipo_rnt === tipo_rnt_establecimiento"
      >
        <label class="small mb-0">Número de empleados</label>
        <p>
          <strong>{{ informacionEstablecimiento.numero_empleados }}</strong>
        </p>
      </div>
    </footer>
  </section>
  <section class="col-12 mb-4 mt-1 border-bottom">
    <footer class="row">
      <ng-container
        *ngIf="informacionEstablecimiento.tipo_rnt === tipo_rnt_establecimiento"
      >
        <h2 class="col-12 h5 font-weight-bold mb-2">
          Datos del establecimiento
        </h2>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Nombre</label>
          <p>
            <strong>{{ informacionEstablecimiento.razon_social }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Dirección</label>
          <p>
            <strong>{{
              informacionEstablecimiento.direccion_comercial
            }}</strong>
          </p>
        </div>
        <div
          class="col-sm-12 col-md-3"
          *ngIf="informacionEstablecimiento.matricula"
        >
          <label class="small mb-0">Matrícula mercantíl</label>
          <p>
            <strong>{{ informacionEstablecimiento.matricula }}</strong>
          </p>
        </div>
      </ng-container>
      <ng-container
        *ngIf="informacionEstablecimiento.tipo_rnt === tipo_rnt_inmueble"
      >
        <h2 class="col-12 h5 font-weight-bold mb-2">Datos del inmueble</h2>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Dirección</label>
          <p>
            <strong>{{
              informacionEstablecimiento.direccion_comercial
            }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Último año renovado</label>
          <p>
            <strong>{{
              informacionEstablecimiento.ultimo_anio_renovado_rnt_rnt
            }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Departamento</label>
          <p>
            <strong>{{ informacionEstablecimiento.departamento }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Municipio</label>
          <p>
            <strong>{{ informacionEstablecimiento.municipio }}</strong>
          </p>
        </div>
      </ng-container>
      <ng-container
        *ngIf="informacionEstablecimiento.tipo_rnt === tipo_rnt_guia"
      >
        <h2 class="col-12 h5 font-weight-bold mb-2">Datos del guía</h2>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Nombre de guia</label>
          <p>
            <strong>{{ informacionEstablecimiento.nombre_gerente }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Dirección</label>
          <p>
            <strong>{{
              informacionEstablecimiento.direccion_comercial
            }}</strong>
          </p>
        </div>
      </ng-container>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Cámara de comercio</label>
        <p>
          <strong>{{
            informacionEstablecimiento.desc_camara_largo ||
              informacionEstablecimiento.descripcion_camara
          }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Categoría</label>
        <p>
          <strong>{{ informacionEstablecimiento.categoria }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Sub categoría</label>
        <p>
          <strong>{{ informacionEstablecimiento.subcategoria }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Actividad económica</label>
        <label class="p-0 h6 font-weight-bold form-control-plaintext"
          >Ver actividades
          <img
            src="../../../../../assets/icons/actividad-economica.png"
            height="30"
            class="pointer"
            alt=""
            (click)="consultarActividades(informacionEstablecimiento)"
          />
        </label>
      </div>
    </footer>
  </section>
  <section class="col-12 row mb-4">
    <h2 class="col-12 h5 font-weight-bold mb-2">
      Datos adicionales del prestador
    </h2>
    <div class="col-sm-12 col-md-4">
      <header class="mb-3">
        <h2 class="h6 font-weight-bold mb-4">Contacto</h2>
      </header>
      <footer class="row">
        <p class="col-5 small">Teléfono Fijo:</p>
        <p class="col-7 font-weight-bold small">
          {{ informacionEstablecimiento.numero_telefonico }}
        </p>
        <p class="col-5 small">Celular:</p>
        <p class="col-7 font-weight-bold small">
          {{ informacionEstablecimiento.numero_celular }}
        </p>
        <p class="col-5 small">Número fax:</p>
        <p class="col-7 font-weight-bold small">
          {{ informacionEstablecimiento.fax }}
        </p>
        <p class="col-5 small">Correo eletrónico:</p>
        <p class="col-7 font-weight-bold small text-large">
          {{ informacionEstablecimiento.correo_electronico }}
        </p>
      </footer>
    </div>
    <div class="col-sm-12 col-md-4">
      <header class="mb-3">
        <h2 class="h6 font-weight-bold mb-4">Notificaciones</h2>
      </header>
      <footer class="row">
        <p class="col-6 small">Departamento notificaciones:</p>
        <p class="col-6 font-weight-bold small">
          {{ informacionEstablecimiento.departamento_notificacion }}
        </p>
        <p class="col-6 small">Municipio notificaciones:</p>
        <p class="col-6 font-weight-bold small">
          {{ informacionEstablecimiento.municipio_notificacion }}
        </p>
        <p class="col-6 small">Teléfono notificaciones:</p>
        <p class="col-6 font-weight-bold small">
          {{ informacionEstablecimiento.numero_telefonico_notificacion }}
        </p>
        <p class="col-6 small">Dirección notificaciones:</p>
        <p class="col-6 font-weight-bold small">
          {{ informacionEstablecimiento.direccion_notificacion }}
        </p>
      </footer>
    </div>
  </section>
</section>
